export enum GoFrensTutorialSteps {
    INITIAL,
    NAB_NFT,
    REP_COMMUNITY,
    RACK_EXP,
    UNLOCK_REWARDS,
}
